import { render, staticRenderFns } from "./PublicApiForbidden.vue?vue&type=template&id=3682bd3c&"
import script from "./PublicApiForbidden.vue?vue&type=script&lang=ts&"
export * from "./PublicApiForbidden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports